import { render } from "./TicketLogs.vue?vue&type=template&id=d2d0aca0&scoped=true"
import script from "./TicketLogs.vue?vue&type=script&lang=js"
export * from "./TicketLogs.vue?vue&type=script&lang=js"

import "./TicketLogs.vue?vue&type=style&index=0&id=d2d0aca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2d0aca0"]])

export default __exports__